import React, { Fragment } from 'react';
import { LeftMenuUser } from '../LeftMenuUser';
import { CurrentUserLimits } from '../../../../slices/current-user/current-user.state';
import { TimelineParty } from '../../../../slices/marketplace/timeline/models/enums/timeline-party.enum';
import { FeatureFlag } from '../../../../containers/FeatureFlags/FeatureFlag';
import { FeatureFlagsEnum } from '../../../../containers/FeatureFlags/FeatureFlags.enum';
import { MyAccountMenuItem } from '../items/MyAccountMenuItem';
import { MyNonprofitMenuItem } from '../items/MyNonprofitMenuItem';
import { NotificationSettingsMenuItem } from '../items/NotificationSettingsMenuItem';
import { MyTeamMembersMenuItem } from '../items/MyTeamMembersMenuItem';
import { MyReferralHubMenuItem } from '../items/MyReferralHubMenuItem';
import { EcosystemHomepageMenuItem } from '../items/EcosystemHomepageMenuItem';
import { MyDealsMenuItem } from '../items/MyDealsMenuItem';
import { ObservingDealsMenuItem } from '../items/ObservingDealsMenuItem';

const HEADING = 'app-sidebar__heading vertical-nav-menu';

export interface CharityAdminMenuProps {
    user: LeftMenuUser;
    limits: CurrentUserLimits;
}

export const CharityAdminMenu = (props: CharityAdminMenuProps) => {
    const { user } = props;
    const charities = user.charities;
    const isReferral = !!user.isReferral;
    const practices = user.practices || [];
    const isMarketplaceBroker = !!user.isMarketplaceBroker;
    const engagements = user.engagements || [];

    const isReferralOrCharityReferral = isReferral && practices.length === 0;
    const showEcosystem =
        (isReferralOrCharityReferral && !charities) ||
        (charities ? charities.length < 1 : false);

    return (
        <Fragment>
            <div id="left-menu" />
            <div>
                <MyAccountMenuItem />
                <FeatureFlag flag={FeatureFlagsEnum.FF_Notifications}>
                    <NotificationSettingsMenuItem />
                </FeatureFlag>
                {charities &&
                    charities.map((charity: any, index: number) => (
                        <MyNonprofitMenuItem
                            key={index}
                            charityId={charity.id}
                            onClickExtra={() => {
                                localStorage.setItem(
                                    'idforCharitybyId',
                                    String(charity.id)
                                );
                                localStorage.setItem(
                                    'idforCharityproposalbyId',
                                    '-'
                                );
                            }}
                        />
                    ))}
                <MyTeamMembersMenuItem className={HEADING} />
                {isReferralOrCharityReferral && (
                    <MyReferralHubMenuItem className={HEADING} />
                )}
            </div>

            {showEcosystem && <EcosystemHomepageMenuItem />}
            {isMarketplaceBroker &&
                engagements.some((e: any) => e.party === TimelineParty.Broker) && (
                    <MyDealsMenuItem engagements={engagements} />
                )}
            {isMarketplaceBroker &&
                engagements.some(
                    (e: any) => e.party === TimelineParty.Observer
                ) && <ObservingDealsMenuItem engagements={engagements} />}
        </Fragment>
    );
};
